import "./menuLeft.css";
import Component from "react-pure-render/component";
import React from "react";
import { Link } from "react-router";
import { IndexLink } from "react-router";
import Isvg from "react-inlinesvg";
import MenuLeftDropdown from "./menuLeftDropdown.react";

export default class MenuLeft extends Component {
  static propTypes = {
    msg: React.PropTypes.object,
    actions: React.PropTypes.object,
    currentUser: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  haveGroup = (user, group) => {
    if (user) {
      let groups = user.groups;

      if (typeof groups.toJS == "function") {
        groups = user.groups.toJS();
      }
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].name == group) {
          return true;
        }
      }
    }
    return false;
  };

  menuClick = e => {
    const { actions } = this.props;
    actions.setSidebar("open", false);
    actions.cleanSearch();
  };

  generateMenu = (menuItems, level, parents) => {
    const { actions, menu, pathname, currentUser, history } = this.props;
    const self = this;
    const menuItemsHTML = menuItems.valueSeq().map(function(item, index) {
      let canDisplay = false;
      if (item.get("visibleFor")) {
        item.get("visibleFor").forEach(function(menuVisibilityItem) {
          currentUser &&
            currentUser.get("groups").forEach(function(group) {
              if (menuVisibilityItem === group.name) {
                canDisplay = true;
              }
            });
        });
      } else {
        canDisplay = true;
      }
      if (canDisplay) {
        if (item.get("type") === "menuItem") {
          return (
            <li key={index} onClick={self.menuClick}>
              <Link
                className={
                  item.get("keepLinkActive") ? pathname.substring(
                    0,
                    item.get("link").length
                  ) === item.get("link") ? (
                    "active"
                  ) : (
                    ""
                  ) : pathname === item.get("link") ? (
                    "active"
                  ) : (
                    ""
                  )
                }
                to={item.get("link")}
              >
                {item.get("icon") && (
                  <Isvg
                    className={item.getIn(["icon", "className"])}
                    src={item.getIn(["icon", "source"])}
                  />
                )}
                {item.get("text")}
                <div className="min-rectangle" />
              </Link>
            </li>
          );
        } else if (item.get("type") === "submenu") {
          return (
            <MenuLeftDropdown
              history={history}
              pathname={pathname}
              submenu={item}
              level={level}
              parents={parents.concat(item.get("name"))}
              key={index}
              actions={actions}
              menu={menu}
            >
              {self.generateMenu(
                item.get("items"),
                level + 1,
                parents.concat(item.get("name"))
              )}
            </MenuLeftDropdown>
          );
        }
      }
    });
    return menuItemsHTML;
  };

  render() {
    const { msg, currentUser, menu, pathname } = this.props;

    const menuItems = menu.get("menuItems")
      ? this.generateMenu(menu.get("menuItems"), 0, [])
      : [];

    let isAdmin = false;

    if (currentUser) {
      currentUser.get("groups").forEach(function(group) {
        if ("admin" === group.name) {
          isAdmin = true;
        }
      });
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 start-xs top-xs menu-left">
        <div className="box">
          <div className="row remove-margin-right">
            <div className="col-xs-12 center-xs">
              <div className="logo" onClick={this.menuClick}>
                <Link to="/orders">
                  <h1>Fluct</h1>
                </Link>
                <div className="hide-mobile-menu visible-xs visible-sm" />
              </div>
            </div>
          </div>
          <div className="row remove-margin-right">
            <div className="col-xs-12 left-xs middle-xs remove-padding-right">
              <div className="box">
                <nav>
                  <ul>
                    {/* Elementy statyczne */}
                    {/*<li onClick={ this.menuClick }>
                      <Link className={pathname==='/' ? "active" : ''} to="/">
                      <Isvg className="icon contract" src="/assets/img/icon_foursquares.svg" />
                      Dashboard
                      <div className="min-rectangle"></div>
                      </Link>
                    </li> */}

                    {/* Elementy dynamiczne */}
                    {menuItems}
                    {isAdmin && (
                      <li onClick={this.menuClick}>
                        <Link
                          className={pathname === "/users" ? "active" : ""}
                          to="/users"
                        >
                          <Isvg
                            className="icon contract"
                            src="/assets/img/icon_users.svg"
                          />
                          Użytkownicy
                          <div className="min-rectangle" />
                        </Link>
                      </li>
                    )}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/menuLeft.react.js